// « Joindre » on a Copilote card: the files an action takes are declared by the server (`card.attachments`: channel, context,
// required, max_files, accept, max_bytes) and sent by the PERSON through the screen's own upload route — never through the model.
// The server checks them again on « Accepter » and when the module attaches them; these rules only spare a useless round trip.

// Where the screen itself sends such a file: Finance receipts, or a module's private files context.
export function uploadTarget(spec) {
  if (spec?.channel === "finance") return { path: "/finance/attachments", params: {} };
  if (spec?.channel === "files" && spec.context) return { path: "/files", params: { context: spec.context } };
  return null;
}

export function photoOnly(spec) {
  return !!spec?.accept?.length && spec.accept.every((type) => type.startsWith("image/"));
}

function problemOf(spec, file) {
  if (!spec.accept.includes(file.type)) {
    return photoOnly(spec) ? `${file.name} : une photo est attendue (JPEG, PNG ou WebP).` : `${file.name} : PDF ou image (JPEG, PNG, WebP) seulement.`;
  }
  if (file.size > spec.max_bytes) return `${file.name} : ${Math.round(spec.max_bytes / (1024 * 1024))} Mo maximum.`;
  return null;
}

// The files picked that may be sent now, and why the others were set aside (type, size, room left).
export function pickable(spec, alreadyCount, picked) {
  const kept = [];
  const problems = [];
  for (const file of picked) {
    const problem = problemOf(spec, file);
    if (problem) problems.push(problem);
    else if (alreadyCount + kept.length >= spec.max_files) problems.push(`${spec.max_files} fichier(s) au plus : ${file.name} n'a pas été ajouté.`);
    else kept.push(file);
  }
  return { kept, problems };
}

// Accepter stays disabled while a file is being sent, and while a required one is missing.
export function filesBlockAccept(spec, files, uploading) {
  if (!spec) return false;
  return uploading || (spec.required && files.length === 0);
}
